import { createFileRoute } from '@tanstack/react-router';
import DepotCreate from '~/containers/DepotCreate';

export const Route = createFileRoute('/depots/new')({
  component: DepotCreate,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
